import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
type TagPillCountProps = {
  count: number;
  isActive: boolean;
};
export default function TagPillCount(t0) {
  const $ = _c(5);
  const {
    count,
    isActive
  } = t0;
  const t1 = isActive ? "bg-vive-primary-80/10 text-vive-primary-80" : "bg-vive-ghost-white text-vive-primary-30 shadow-[inset_0_0_0_1px_rgba(255,255,255,0.05)]";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("min-w-5 rounded-full px-1.5 py-0.5 text-center text-[11px] leading-none tabular-nums transition-colors", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== count || $[3] !== t2) {
    t3 = <div className={t2}>{count}</div>;
    $[2] = count;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}